// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Vl1s","footer":"ModalInfo_footer__1K9BD"};